<template>
    <label class="image-item" :for="_uid" v-bind:class="{ 'has-image': imageData.length > 0 }">
        <input type="hidden" :name="finalInputName"/>

        <input type="file" v-validate="'mimes:image/*'" accept="image/*" :name="finalInputName" ref="imageInput" :id="_uid" @change="addImageView($event)" :required="required ? true : false" />

        <img class="preview" :src="imageData" v-if="imageData.length > 0">

        <button type="button" class="btn btn-danger remove-image" @click="removeImage()">
            <i class="fas fa-trash-alt"></i> 
            {{ removeButtonLabel }}
        </button>
    </label>
</template>

<script>
    export default {
        props: {
            inputName: {
                type: String,
                required: false,
                default: 'attachments'
            },

            removeButtonLabel: {
                type: String,
            },

            image: {
                type: Object,
                required: false,
                default: null
            },

            required: {
                type: Boolean,
                required: false,
                default: false
            }
        },

        data: function() {
            return {
                imageData: ''
            }
        },

        mounted () {
            if(this.image.id && this.image.url) {
                this.imageData = this.image.url;
            }
        },

        computed: {
            finalInputName () {
                return this.inputName + '[' + this.image.id + ']';
            }
        },

        methods: {
            addImageView () {
                var imageInput = this.$refs.imageInput;

                if (imageInput.files && imageInput.files[0]) {
                    if(imageInput.files[0].type.includes('image/')) {
                        var reader = new FileReader();

                        reader.onload = (e) => {
                            this.imageData = e.target.result;
                        }

                        reader.readAsDataURL(imageInput.files[0]);
                    } else {
                        imageInput.value = "";
                        this.alertMessage(translate('app.extra.image.validation'));
                    }
                }
            },

            removeImage () {
                this.$emit('onRemoveImage', this.image)
            }
        }
    };
</script>
